import {
  type SceneData,
  SceneType,
  type KrpPlayer,
  type CFSceneSwitchType,
} from '@types';
import { THUMB_DOMAIN } from '@constants';
import { sendError } from '@components/Noti';
import getPanoUrl from '@utils/getPanoUrl';
import getPanoViewTrackList from '@utils/getPanoViewTrackList';

type Options = {
  keepView?: boolean;
  blendType?: CFSceneSwitchType;
  onComplete?: () => void;
  onAnimationComplete?: () => void;
};

function loadScene({
  player,
  data,
  options = {},
}: {
  player: KrpPlayer | null;
  data: SceneData | null;
  options?: Options;
}) {
  if (!player || !data) return;
  const {
    type,
    view,
    path,
    multires,
    cdnDomain,
    thumbUrl,
    transcodeTrack,
    matrixFov,
  } = data;
  const {
    keepView = false,
    blendType = 0,
    onComplete,
    onAnimationComplete,
  } = options;

  if (onAnimationComplete) {
    player.callbacks.onAnimationComplete = onAnimationComplete;
  }

  if (type === SceneType.pano) {
    player.loadCube(
      {
        url: getPanoUrl({ cdnDomain, path }),
        view,
        multires,
        keepView,
        blendType,
      },
      onComplete
    );
  } else if (type === SceneType.panoVideo) {
    const tracks = getPanoViewTrackList({ cdnDomain, transcodeTrack });
    if (tracks.length) {
      player.loadVideo(
        {
          videoUrl: tracks[tracks.length - 1].url,
          view,
          posterUrl: `${THUMB_DOMAIN}/${thumbUrl}`,
          keepView,
          blendType,
        },
        onComplete
      );
    } else {
      sendError('全景视频地址错误');
    }
  } else if (type === SceneType.matrix) {
    player.loadFlat(
      {
        url: getPanoUrl({ cdnDomain, path }),
        multires,
        matrixFov,
        view,
        keepView,
        blendType,
      },
      onComplete
    );
  }
}

export default loadScene;
